import React from 'react';
import Image from "../../elements/Image";
import Image1 from '../../../assets/images/image2.webp';
import Image2 from '../../../assets/images/image3.webp';
import Image3 from '../../../assets/images/image4.webp';
import Image4 from '../../../assets/images/image5.webp';
import Button from "../../form/Button";

// JSON-like data
// const missionData = {
//   images: [
//     { src: Image1, alt: "Mission Image 1", colSpan: 5, rowSpan: 7, colStart: 1, rowStart: 2, mt: "mt-6" },
//     { src: Image2, alt: "Mission Image 2", colSpan: 5, rowSpan: 7, colStart: 6, rowStart: 1, mt: "mt-6" },
//     { src: Image3, alt: "Mission Image 3", colSpan: 5, rowSpan: 6, colStart: 1, rowStart: 9, mt: "" },
//     { src: Image4, alt: "Mission Image 4", colSpan: 5, rowSpan: 7, colStart: 6, rowStart: 8, mt: "" },
//   ],
//   titleSmall: "Company Culture",
//   titleBig: "Culture at Trhurst Tech",
//   description: "Trhurst Tech is a global fintech company creating innovative solutions that bridge the gap between digital assets and today’s financial systems.<br/><br/> Our mission is to simplify and secure the way individuals and businesses interact with digital currencies, making financial access more seamless, compliant, and user-friendly.<br/><br/> Headquartered across the UK, US, Ireland, and Poland, our team of 160+ professionals brings together global expertise and a shared passion for financial innovation.",
//   buttonText: "Join Our Team",
// };

const OurMission = ({data}) => {
  console.log("Mission Data:", data);
  return (
    <div className="relative w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
      <div className="relative flex flex-col lg:flex-row gap-16 items-center">

        {/* Zig-Zag Image Grid */}
        <div className="grid grid-cols-10 grid-rows-14 gap-6 w-1/2">
          {data.images.map((img, index) => (
            <div
              key={index}
              className={`col-span-${img.colSpan} row-span-${img.rowSpan} col-start-${img.colStart} row-start-${img.rowStart}`}
            >
              <div className={`w-full aspect-square overflow-hidden rounded-3xl ${img.mt}`}>
                <Image
                  src={img.src}
                  width="100%"
                  height="100%"
                  alt={img.alt}
                  classes="object-cover w-full h-full"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Text Content */}
        <div className="w-full lg:w-1/2 text-white">
          <h4 className="text-xl leading-3 mb-2 font-semibold text-primary uppercase">{data.titleSmall}</h4>
          <h2 className="text-5xl leading-normal font-semibold mb-5">{data.titleBig}</h2>
          <div className="text-xl leading-relaxed text-secondary">
            <p dangerouslySetInnerHTML={{ __html: data.description }} />
          </div>
          <Button
            buttonClasses={"!h-12 xls:!h-14 !rounded-4 !px-4 md:!px-8 !border !border-primaryBorder md:!min-w-[180px] uppercase mt-10 font-semibold text-base xl:!text-lg"}
            buttonHasLink={false}
            buttonType={'button'}
            buttonLabel={data.buttonText}
            buttonLabelClasses={""}
          />
        </div>

      </div>
    </div>
  );
};

export default OurMission;
